import { useMemo } from "react";
import { usePrismicDocumentByUID } from "@prismicio/react";
import _get from "lodash/get";
import LoadingAnimation from "../components/LoadingAnimation";
import { PageNotFound } from "../pages";
import { MASTER_COURSES } from "../config/constants";

export function withDocumentPrismicByUID(Component) {
  return function WrappedComponent(props) {
    const slug = useMemo(() => _get(props.match, "params.slug"), [props.match]);
    const [course, { state }] = usePrismicDocumentByUID(
      props.contentType ?? MASTER_COURSES,
      props.customSlug ? props.customSlug : slug
    );
    if (state === "idle" || state === "loading") {
      return <LoadingAnimation />;
    }

    if (slug === null || state === "failed") {
      return <PageNotFound />;
    }

    return <Component {...props} course={course} slug={slug} />;
  };
}
